var path = 'jangl/jangl-select/template.html';
var html = "<div class=form-group> <label for={{$ctrl.name}} class=control-label ng-class=\"{ 'required': $ctrl.required}\" ng-if=!$ctrl.hideLabel> {{$ctrl.label}} </label> <label ng-if=$ctrl.hideLabel></label> <select class=form-control name={{$ctrl.name}} ng-model=$ctrl.model ng-required=$ctrl.required ng-options=\"item.key as item.label for item in $ctrl._options\" ng-disabled=$ctrl.disabled> <option value=\"\" ng-if=$ctrl.emptyOption></option> </select> <div class=error-messages ng-if=$ctrl.required ng-show=$ctrl.form.$submitted> <div ng-show=$ctrl.form[$ctrl.name].$error.required>{{$ctrl.label}} is required.</div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/jangl/jangl-select/template.html
// module id = 370
// module chunks = 0